import { useEffect, useState } from 'react';
import OneliveCoinHistoryPanel from './OneliveCoinHistoryPanel';
import OneliveMypageHistoryContent from './OneliveMypageHistoryContent';
import { isMypageHub, readMypageProfileTab, resolveMypageProfileTab, type MypageProfileTab } from './mypageMenu';

const DESKTOP_MQ = '(min-width: 769px)';

function isPcViewport() {
  return typeof window !== 'undefined' && window.matchMedia(DESKTOP_MQ).matches;
}

function readPathname() {
  return window.location.pathname.replace(/\/$/, '') || '/';
}

export default function OneliveMypageProfileContent() {
  const [pathname, setPathname] = useState(readPathname);
  const [tab, setTab] = useState<MypageProfileTab | null>(() => resolveMypageProfileTab(readPathname()));

  useEffect(() => {
    const sync = () => {
      const nextPath = readPathname();
      setPathname(nextPath);
      setTab(resolveMypageProfileTab(nextPath));
    };
    window.addEventListener('popstate', sync);
    const timer = window.setInterval(sync, 500);
    return () => {
      window.removeEventListener('popstate', sync);
      window.clearInterval(timer);
    };
  }, []);

  if (!isMypageHub(pathname)) return null;

  // 모바일: 탭 미선택 시 메뉴만 표시, 코인/충전/환전 내역은 메뉴 하단 인라인
  if (!isPcViewport() && !readMypageProfileTab()) {
    return null;
  }

  const activeTab = tab || (isPcViewport() ? 'coin' : null);
  if (!activeTab) return null;

  if (activeTab === 'coin') {
    return <OneliveCoinHistoryPanel embedded />;
  }

  return <OneliveMypageHistoryContent variant={activeTab} />;
}
